module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[70]435.285adb7.woff2";